<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select size="small" style="width: 100px;margin-right: 20px" v-model="query.status">
                        <el-option v-for="item in statusList" :key="item.subentry" :label="item.dictPrompt" :value="item.subentry"></el-option>
                    </el-select>
                    <el-input size="small"
                              placeholder="请输入员工姓名"
                              suffix-icon="el-icon-search"
                              style="width: 220px;margin-right: 20px"
                              v-model="query.realName">
                    </el-input>
                    <el-input size="small"
                              placeholder="请输入员工手机号"
                              suffix-icon="el-icon-search"
                              style="width: 220px;margin-right: 20px"
                              v-model="query.mobile">
                    </el-input>
<!--                    <el-input size="small"-->
<!--                              placeholder="请输入员工角色"-->
<!--                              suffix-icon="el-icon-search"-->
<!--                              style="width: 220px;margin-right: 20px"-->
<!--                              v-model="query.roleName">-->
<!--                    </el-input>-->
                </div>
                <div>
                    <el-button type="primary" @click="AddStaff" style="width: 96px">新增员工</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="realName" label="员工姓名"></el-table-column>
                    <el-table-column prop="mobile" label="手机号"></el-table-column>
                    <el-table-column prop="roleName" label="所属角色"></el-table-column>
                    <el-table-column  label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.user_status === '0'" style="color:#999999;">冻结</span>
                            <span v-else-if="scope.row.user_status === '1'">正常</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" class="mr20" @click="editStaffData(scope.row)">编辑</el-button>
                            <el-button type="text" @click="openSet(scope.row)">配置可建角色</el-button>
                            <el-tooltip class="item" effect="dark" content="配置后可赋予该账号新建对应角色账号的权限。" placement="top-end" offset="-40">
                                <i class="el-icon-question" style="color: rgba(97,167,255,1);margin-left: 0"></i>
                            </el-tooltip>
                            <el-button v-if="scope.row.user_status === '0'" type="text" class="ml10" @click="relieveStaff(scope.row)">解冻</el-button>
                            <el-button v-else-if="scope.row.user_status === '1'" type="text"  class="delete-button ml10" @click="deleteStaff(scope.row)">冻结</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="pageNum"
                            :page-size="pageSize"
                            :total="total"
                            @current-change="handlePageChange"
                    ></el-pagination>
                </div>
            </div>
        </div>
<!--    新增员工弹窗-->
        <el-dialog title="新增员工" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="staffAdd" :rules="rules" ref="add" label-width="80px" size="small">
                <el-form-item label="姓名" prop="realName">
                    <el-input v-model="staffAdd.realName"  style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roleId">
                    <el-select v-model="staffAdd.roleId" style="width: 282px" placeholder="请选择">
                        <el-option
                                v-for="item in role"
                                :key="item.roleId"
                                :label="item.roleName"
                                :value="item.roleId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="staffAdd.mobile" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="staffAdd.password" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <!--    编辑员工弹窗-->
        <el-dialog title="编辑员工" :visible.sync="dialogEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="staffEdit" :rules="rules" ref="edit" label-width="80px" size="small">
                <el-form-item label="姓名" prop="realName">
                    <el-input v-model="staffEdit.realName"  style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roleId">
                    <el-select v-model="staffEdit.roleId" style="width: 282px" placeholder="请选择">
                        <el-option
                                v-for="item in role"
                                :key="item.roleId"
                                :label="item.roleName"
                                :value="item.roleId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="staffEdit.mobile" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="passwords">
                    <el-input v-model="staffEdit.password" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="editConfirm" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="配置可建角色" :visible.sync="dialogSetVisible" width="700px" :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        style="text-align: left; display: inline-block"
                        v-model="roleIdList"
                        filterable
                        filter-placeholder="搜索角色名称"
                        ref="role"
                        :titles="['角色', '当前已选择']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        :props="{
                            key: 'roleId',
                            label: 'roleName',
                        }"
                        :data="role">
                    <span slot-scope="{ option }">{{ option.roleName }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSetVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="saveSet" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                statusList: [],
                // 搜索框值
                query:{
                    status: '',
                    realName: '',
                    mobile: '',
                    roleName: '',
                },
                // 员工列表信息
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                // 员工可选角色
                role:[],
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增弹窗表单数据
                staffAdd: {
                    realName:"",
                    mobile:"",
                    roleId:"",
                    password: '',
                },
                // 新增弹窗表单数据验证
                rules: {
                    realName: [{required: true, message: '请输入员工姓名', trigger: 'blur'}],
/*                    mobile: [
                        {required: true, message: '手机号不能为空', trigger: 'blur'},
                        {pattern: /^[1][3-9][0-9]{9}$/, message: '手机号格式错误', trigger: 'blur'}
                    ],*/
                    roleId: [{required: true, message: '请选择员工角色', trigger: 'change'}],
                    password: [{required: true, message: '请输入员工姓名', trigger: 'blur'}]
                },
                // 编辑弹窗角色数据
                staffEdit: {
                    userId: '',
                    realName: '',
                    mobile: '',
                    roleId: '',
                    password: ''
                },
                dialogSetVisible: false,
                userId: '',
                roleIdList: [],
            }
        },
        methods: {
            // 查询员工列表
            getData() {
                this.loading = true
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    realName: this.query.realName,
                    userStatus: this.query.status,
                    mobile: this.query.mobile
                }
                this.axios.post('/api-u/10024/100121',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res =>{
                    if(res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                        } else {
                            this.$message.info('暂无员工')
                            this.tableData = []
                        }
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 列表下一页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            // 获取状态
            getStatus() {
                this.axios.get('/api-b/10040/100157/000007',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.statusList = res.data.data
                        this.query.status = res.data.data[0].subentry
                    } else {
                        this.$message.error(res.data.message)
                        this.loading = false
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            // 查询本人可支配角色角色
            getRole() {
                return new Promise((resolve,reject) => {
                    this.axios.get('/api-u/10042/100161',{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res =>{
                        if (res.data.code === 10000) {
                            if(res.data.data !== null) {
                                this.role = res.data.data
                            } else {
                                this.role = []
                            }
                            resolve()
                        } else {
                            this.$message.error(res.data.message);
                            reject()
                        }
                    })
                })
            },
            // 打开增加员工弹窗
            AddStaff(){
                this.getRole()
                // this.getHospital()
                this.dialogAddVisible = true
            },
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 确认增加员工
            confirmAdd(){
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {
                            realName: this.staffAdd.realName,
                            roleId: this.staffAdd.roleId,
                            mobile: this.staffAdd.mobile,
                            password: this.staffAdd.password
                        }
                        if (this.staffAdd.departmentId !== '') {
                            params.departmentId = this.staffAdd.departmentId
                        }
                        this.axios.post('/api-b/10024/100118',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogAddVisible = false
                                this.getData()
                                this.$nextTick(()=>{
                                    this.$refs.add.resetFields();
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        }).catch(() => {})
                    } else {
                        this.$message.error('请按照提示正确填写相关信息')
                    }
                })
            },
            // 打开编辑员工弹窗
            editStaffData(data) {
                this.getRole()
                this.dialogEditVisible = true;
                this.staffEdit = JSON.parse(JSON.stringify(data));
            },
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 确定编辑员工
            editConfirm() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        const h = this.$createElement;
                        this.$msgbox({
                            message: h('div',{class:'message-box'}, [
                                h('div', { class: 'message-title-box'}, [
                                    h('i', { class:'el-icon-warning message-box-icon' }, ''),
                                    h('span', { class:'message-box-title'}, '确认修改员工信息？'),
                                ]),
                                h('div', null, [
                                    h('span', { class:'message-box-main'}, '信息修改后请及时通知对应员工，以免无法正常登陆使用。'),
                                ]),
                            ]),
                            showCancelButton: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(() => {
                            let params = {
                                userId: this.staffEdit.userId,
                                realName: this.staffEdit.realName,
                                roleId: this.staffEdit.roleId,
                                mobile: this.staffEdit.mobile,
                            }
                            if (this.staffEdit.password !== undefined && this.staffEdit.password !== '') {
                                params.password = this.staffEdit.password
                            }
                            this.axios.post('/api-u/10024/100050',params,{
                                headers:{
                                    Authorization: this.authorization
                                }
                            }).then(res => {
                                if (res.data.code === 10000) {
                                    this.$message.success(res.data.message)
                                    this.getData()
                                    this.dialogEditVisible = false
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }).catch(error => {})
                    } else {
                        this.$message.error('请按照提示正确填写相关信息')
                    }
                })
            },
            deleteStaff(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要删除该员工账号吗？'),
                        ]),
                        h('div', null, [
                            h('span', { class:'message-box-main'}, '删除后，该员工将无法正常登陆。'),
                        ]),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append('userId',data.userId)
                    this.axios.post('/api-u/10024/100119',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })
            },
            relieveStaff(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要恢复该员工账号吗？'),
                        ]),
                        h('div', null, [
                            h('span', { class:'message-box-main'}, '恢复后，该员工将可以正常登陆。'),
                        ]),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append('userId',data.userId)
                    this.axios.post('/api-u/10024/100120',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        console.log(res)
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    })
                }).catch(error => {})
            },
            getUserRole(data) {
                return new Promise((resolve, reject) => {
                    this.axios.get('/api-u/10042/100162/' + data,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        this.roleIdList = []
                        if (res.data.code === 10000) {
                            for (let i=0;i<res.data.data.length;i++) {
                                this.roleIdList.push(res.data.data[i].roleId)
                            }
                        } else {
                            this.$message.error(res.data.message)
                        }
                        resolve()
                    })
                })
            },
            openSet(data) {
                Promise.race([this.getRole(),this.getUserRole(data.userId)]).then(() => {
                    this.dialogSetVisible = true
                    this.userId = data.userId
                })
            },
            saveSet() {
                let params = {
                    userId: this.userId,
                    roleIdList: this.roleIdList,
                }
                this.axios.post('/api-u/10042/100163',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogSetVisible = false
                        this.getData()
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
        },
        watch: {
            // 监听搜索框值变化,请求列表数据
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            },
        },
        created() {
             this.getData()
            this.getStatus()
        }
    }
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-tooltip__popper.is-dark {
        background: #FFFFFF;
        color: #000;
        width: 160px;
        box-shadow:0 9px 28px 8px rgba(0,0,0,0.05),0 6px 16px 0 rgba(0,0,0,0.08),0 3px 6px -4px rgba(0,0,0,0.12);
    }
    .el-tooltip__popper[x-placement^=top-end] .popper__arrow::after {
        border-top-color: #FFFFFF;
    }
    .el-tooltip__popper[x-placement^=top-end] .popper__arrow{
        border-top-color:#FFFFFF;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .ml10 {
        margin-left: 10px;
    }
</style>